import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { UserData } from '../model/UserData';
import { LogsData } from '../model/LogsData';
import { coach } from '../model/coach';
import { CookieService } from 'ngx-cookie-service';
import { QuizData } from '../questionaire/QuizData';
import { RiskquizComponent } from '../questionaire/riskquiz/riskquiz.component';
import { userInfo } from 'os';
import { RegisterComponent } from '../register-component/register-component.component';
import { Logs } from 'selenium-webdriver';
// import { HttpClient } from 'selenium-webdriver/http';
// import { query } from '@angular/core/src/render3';


@Injectable({
  providedIn: 'root'
})
export class BackOffServiceService {

  LoggedIn = false;

  constructor(private cookie: CookieService, private http: HttpClient) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }


  public getStores() {
    const Stores = Parse.Object.extend('Stores');
    const query = new Parse.Query(Stores);
    return query.find()
  }

  public setupIsDone()  {
    const IsDone = Parse.Object.extend("isDone");
    const isDone = new IsDone();
    isDone.set('isLifestyleDone', false);
    //isDone.set("isDoc", false);
    isDone.set("isFirstChecklist", true);
    isDone.set("isFoodQuizDone", false);
    isDone.set("isSdohQuizDone", false);
    isDone.set("ProgramReminder", false);
    isDone.set("LogReminder", false);
    isDone.set("EnrollMessageSent", false);
    //isDone.set("isCoach", false);
    isDone.set("qualify", false);
    
    isDone.set("user_id", this.getObjectId());
    return isDone.save();
  }

  public async getisDone(): Promise<boolean[]> {

    const query = new Parse.Query('isDone');
    const w: boolean[] = [];
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();

    const user_query = new Parse.Query('User');
    user_query.equalTo('objectId', this.getObjectId());
    const user_profile = await user_query.find();
    // if (user_profile[0].get('program_id') !== undefined && user_profile[0].get('program_id') !== ""){
    //   user_profile[0].set("is_enrolled", true);
    //   this.setisEnrolled();
    // }
    w.push(results[0].get('isLifestyleDone'));
    w.push(user_profile[0].get('is_doctor'));
    w.push(results[0].get("isFirstChecklist"));
    w.push(results[0].get("isFoodQuizDone"));
    w.push(user_profile[0].get('is_coach'));
    w.push(results[0].get("isSdohQuizDone"));
    w.push(user_profile[0].get("is_enrolled"));

    return w;
  }

  public async getCoachPrograms(): Promise<coach[]> {
    const programData = [];
    const query = new Parse.Query('Program');
    query.equalTo('coach_id', this.getObjectId());
    query.ascending('program_code');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new coach();
      data.programCode = results[i].get('program_code');
      data.programTitle = results[i].get('title');
      data.programDesc = results[i].get('desc');
      programData.push(data);
    }
    return programData;
  }

  public async getSumName(): Promise<coach[]> {
    const programData = [];
    const user = new coach();
    const query = new Parse.Query('User');
    query.equalTo('access_code', user.sumAccess);
    query.descending('objectId');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new coach();
      data.sumName = results[i].get('name');
      programData.push(data);
    }
    return programData;
  }


  public async setisLifestyleDone() {
    let query = new Parse.Query('isDone');
    let objId: string;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    objId = results[0].id;

    query = new Parse.Query('isDone');
    query.get(objId).then((user) => {
      user.set('isLifestyleDone', true);
      user.save();
    }, (error) => {
      console.log('ERROR updating lifestyle done');
      console.log(error);

    });
  }

  public async setisFoodQuizDone() {
    let query = new Parse.Query('isDone');
    let objId: string;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    objId = results[0].id;

    query = new Parse.Query('isDone');
    query.get(objId).then((user) => {
      user.set('isFoodQuizDone', true);
      user.save();
    }, (error) => {
      console.log('ERROR updating foodquiz done');
      console.log(error);

    });
  }

  /*
  public async setisSdohQuizDone() {
    var query = new Parse.Query("isDone")
    var objId : string;
    query.equalTo("user_id", this.getObjectId());
    const results = await query.find();
    objId = results[0].id;

    query = new Parse.Query("isDone");
    query.get(objId).then((user)=>{
      user.set("isSdohQuizDone", true);
      user.save();
    }, (error) => {
      console.log("ERROR updating sdohquiz done");
      console.log(error);

    })
  }
  */


  public signUp(userRegistrationData :UserData): Promise <any> {
    const User = Parse.Object.extend('User');
    var user = new User();
    
    user.set("name",userRegistrationData.FullName);
    user.set("password",userRegistrationData.password);
    user.set("email",userRegistrationData.Email);
    user.set("username", userRegistrationData.Email);
    user.set("register_code",userRegistrationData.access);
    user.set("programGoalId", userRegistrationData.progGoalId);
    user.set("is_enrolled", false);

    console.log('set Parse.User info');
    this.LoggedIn = true;

    return user.signUp();
  }

  // public async setisEnrolled() {
  //   let query = new Parse.Query('User');
  //   query.get(this.getObjectId()).then((user) => {
  //     user.set('is_enrolled', true);
  //     user.save();
  //   }, (error) => {
  //     console.log('ERROR updating is enrolled');
  //     console.log(error);
  //   });
  // }

  public async checkIsFirstChecklist(): Promise<Boolean> {
    const query = new Parse.Query('isDone');
    let w: boolean;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    w = results[0].get('isFirstChecklist');
    return w;
  }

  public async setIsFirstChecklist() {
    let query = new Parse.Query('isDone');
    let objId: string;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    objId = results[0].id;

    query = new Parse.Query('isDone');
    query.get(objId).then((user) => {
      user.set('isFirstChecklist', false);
      user.save();
    }, (error) => {
      console.log('ERROR updating first checklist');
      console.log(error);
    });
  }

  public setProgramgoals(userUpdated: UserData): void {
    const query = new Parse.Query('ProgramGoals');
    console.log('set ' + this.getProgramGoalsId());
    this.getProgramGoalsId().then((res) => {
      query.get(res).then((user) => {
        console.log('in here');
        // The object was retrieved successfully and it is ready to update.
        user.set('activityGoal', userUpdated.activityGoal);
        user.set('weightGoal', userUpdated.weightGoal);
        user.set('stepsGoal', userUpdated.stepsGoal);
        user.set('activitycaloriesGoal', userUpdated.activitycaloriesGoal);
        user.set('foodcaloriesGoal', userUpdated.foodcaloriesGoal);
        // user.set("access_code", userUpdated.aCode);
        // user.set('program_id', userUpdated.program_id);
        user.save();
        console.log('SUCCEEDED in updating program goals data');
      }, (error) => {
        console.log(error);
        console.log('ERROR updating program goals data');
        // The object was not retrieved successfully.
      });
    });

    const query_user = new Parse.Query('User');
    query_user.get(this.getObjectId()).then(
      (user_data) => {
        user_data.set('program_id', userUpdated.program_id);
        user_data.save();
      },
      (error) => {
        console.log('ERROR updating program goals data');
      }
    );
  }

  public setPhone(userUpdated: UserData): void {
    const user_query = new Parse.Query('User');
    // console.log('set '+ this.getProgramGoalsId());
    user_query.get(this.getObjectId()).then((user) => {
      //  console.log("in here")
      // The object was retrieved successfully and it is ready to update.
      user.set('phoneNumber', userUpdated.phone_number);
      user.save();
      this.sendWelcome(userUpdated.phone_number);
      // .subscribe(
      //   (res) => {
      //     console.log('sms sent');
      //   },
      //   (err) => {
      //     console.log('sms failed');
      //   }
      //);
      console.log('SUCCEEDED in updating program goals data');
    }, (error) => {
      // console.log(error);
      console.log('ERROR updating Phone Number');
      // The object was not retrieved successfully.
    });

  }

  public sendWelcome(phoneNumber) {

    // const query = new Parse.Query('sms_message_template');
    // query.equalTo("template_id", "MSGID0001");
    // const results = await query.find();
    const message_content = 'Welcome to your Viora program.Based on your personalized program. \
    I will connect you to a care navigator and DPP coach. Do you want to connect to a DPP coach?\
    Text yes or no';

    phoneNumber = phoneNumber.toString().replace('-', '');
    console.log('sending welcome message' + phoneNumber);


    // return this.http.post('http://127.0.0.1:5000/send_sms?to_number=' + phoneNumber + '&message_body=' + message_content, '').pipe(map(
    //   data => {
    //     console.log(data);
    //     return data;
    //   }
    // ));
    const SMSAlert = Parse.Object.extend('sms_notifications');
    const object_sms = new SMSAlert();
    object_sms.set('from', '+12152347307');
    object_sms.set('to', phoneNumber);
    object_sms.set('message_content', message_content);
    object_sms.set('status', 'draft');
    object_sms.save();

  }


  // risk quiz
  public createRiskQuiz(): Promise<any> {
    const RiskQuiz = Parse.Object.extend('RiskQuiz');
    const rquiz = new RiskQuiz();
    return rquiz.save();
  }

  public async getAccessCode() {
    const accessCodes = [];
    const query = new Parse.Query('registration');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      accessCodes.push(results[i].get("registration_code"));
    }
    return accessCodes;
  }

  public async getAccessRegexPattern(): Promise<any> {
    const query = new Parse.Query('registration');
    const results = await query.find();
    var accessRegexPattern = "(" + results[0].get("registration_code");
    for (let i = 1; i < results.length; i++) {
      accessRegexPattern = accessRegexPattern + "|" +results[i].get("registration_code");
    }
    accessRegexPattern = accessRegexPattern + ")";
    return accessRegexPattern.toString();
  }

  public createProgramGoals(): Promise<any> {
    const ProgramGoal = Parse.Object.extend('ProgramGoals');
    const prog = new ProgramGoal();
    return prog.save();
  }

  public setProgGoalUserId(id: string): void {
    const query = new Parse.Query('ProgramGoals');
    let pid;
    this.getProgramGoalsId().then((res) => {
      pid = res;
      query.get(pid).then((user) => {
        user.set('user_id', id);
        user.save();
      }, (error) => {
        console.log('ERROR setting program goals id');
        console.log(error);
      });

    });
  }

  public createFoodLog(foodData:any) : Promise <any> {
    const FoodLog = Parse.Object.extend('Food');
    const d = new Date(foodData.foodDate);
    const foodLog = new FoodLog();
    foodLog.set('portion', foodData.portion);
    foodLog.set('food_name', foodData.food_name);
    foodLog.set('meal_type', foodData.meal_type);
    foodLog.set('prep_type', foodData.prep_type);
    foodLog.set('measure', foodData.measure);
    foodLog.set('date', d);
    foodLog.set('calories', foodData.calories);
    foodLog.set('user_id', this.getObjectId());
    return foodLog.save();
  }

  public createWeightLog(weightData: any): Promise<any> {
    const WeightLog = Parse.Object.extend('Weight');

    const weightLog = new WeightLog();
    const d = new Date(weightData.weightDate);
    weightLog.set('weight', weightData.weight);
    weightLog.set('BMI', weightData.BMI);
    weightLog.set('date', d);
    weightLog.set('user_id', this.getObjectId());
    return weightLog.save();
  }
  /*
    public coachClassLog(classData:any) : Promise <any> {
      const ClassLog = Parse.Object.extend("CoachData");

      const classLog = new ClassLog()
      const d = new Date(classData.coachDate);
      classLog.set("class_date", d);
      classLog.set("user_id", classData.user_id);
      classLog.set("attendance", classData.attendance);
      classLog.set("wkly_activity_mins", classData.activity_mins);
      classLog.set("weight", classData.weight);
      return classLog.save();
    }*/

  public setActivityPlan(activityPlanData: any): Promise<any> {
    const ActivityPlan = Parse.Object.extend('ExercisePlan');
    const activityPlan = new ActivityPlan();

    activityPlan.set('specific', activityPlanData.planactivity);
    activityPlan.set('measurable', activityPlanData.planminutes);
    activityPlan.set('day', activityPlanData.activitydays);
    activityPlan.set('status', 'ongoing');

    activityPlan.set('user_id', this.getObjectId());
    return activityPlan.save();
  }

  public setFoodPlan(foodPlanData: any): Promise<any> {
    const ActivityPlan = Parse.Object.extend('FoodPlan');
    const activityPlan = new ActivityPlan();

    activityPlan.set('plan', foodPlanData.foodplan);
    activityPlan.set('measurable', foodPlanData.plannedTimes);
    activityPlan.set('currentTime', foodPlanData.currentTimes);
    activityPlan.set('specific', foodPlanData.plannedFood);
    activityPlan.set('status', 'ongoing');
    activityPlan.set('days', foodPlanData.days);

    activityPlan.set('user_id', this.getObjectId());
    return activityPlan.save();
  }

  public updateFoodPlanStatus(status: string, id: string) {
    const query = new Parse.Query('FoodPlan');
    return query.get(id).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set('status', status);
      user.save();
      console.log('SUCCEEDED in updating food plan status');
    }, (error) => {
      console.log(error);
      console.log('ERROR updating food plan status');
      // The object was not retrieved successfully.
    });
  }

  public updateActivityPlanStatus(status: string, id: string) {
    const query = new Parse.Query('ExercisePlan');
    return query.get(id).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      console.log('about to update status');
      user.set('status', status);
      user.save();
      console.log('SUCCEEDED in updating activity plan status');
    }, (error) => {
      console.log(error);
      console.log('ERROR updating activity plan status');
      // The object was not retrieved successfully.
    });
  }

  public setlifestylequiz(lifestyleQuizData: any): Promise<any> {
    const LifestyleQuiz = Parse.Object.extend('LifestyleQuiz');
    const lifestyleQuiz = new LifestyleQuiz();

    lifestyleQuiz.set('loggingchallenges', lifestyleQuizData.loggingchallenges);
    /*
    lifestyleQuiz.set('freetime', lifestyleQuizData.freetimes);
    lifestyleQuiz.set('favoriteexercise', lifestyleQuizData.favoriteexercises);
    lifestyleQuiz.set('overeattrig', lifestyleQuizData.overeattrigs);
    */
    lifestyleQuiz.set('lvlstress', lifestyleQuizData.lvlstress);
    /*
    lifestyleQuiz.set('reasonstress', lifestyleQuizData.reasonstress);
    lifestyleQuiz.set('dealstress', lifestyleQuizData.dealstress);
    */
    lifestyleQuiz.set('smoke', lifestyleQuizData.smoke);
    lifestyleQuiz.set('hoursSleep', lifestyleQuizData.hoursSleep);
    //lifestyleQuiz.set('qualitySleep', lifestyleQuizData.qualitySleep);
    lifestyleQuiz.set('exerciseMoreThan30', lifestyleQuizData.exerciseMore30);
    /*
    lifestyleQuiz.set('maritalStatus', lifestyleQuizData.maritalStatus);
    lifestyleQuiz.set('enjoywork', lifestyleQuizData.enjoywork);
    lifestyleQuiz.set('dailysleep', lifestyleQuizData.dailysleep);
    lifestyleQuiz.set('weeklyexercise', lifestyleQuizData.weeklyexercise);
    lifestyleQuiz.set('stayuplate', lifestyleQuizData.stayuplate);
    lifestyleQuiz.set('worklong', lifestyleQuizData.worklong);
    lifestyleQuiz.set('watchplaybrowse', lifestyleQuizData.watchplaybrowse);
    lifestyleQuiz.set('socialsupport', lifestyleQuizData.socialsupport);
    */
    lifestyleQuiz.set('lifestyleDone', 1);

    lifestyleQuiz.set('user_id', this.getObjectId());
    return lifestyleQuiz.save();
  }

  public setfoodquiz(foodQuizData: any): Promise<any> {
    const FoodQuiz = Parse.Object.extend('FoodQuiz');
    const foodQuiz = new FoodQuiz();

    foodQuiz.set('typicalmeals', foodQuizData.typicalmeals);
    //foodQuiz.set('ownmeals', foodQuizData.ownmeals);
    foodQuiz.set('fastFood', foodQuizData.fastFood);
    foodQuiz.set('fruitsAndVeggies', foodQuizData.fruitsAndVeggies);
    foodQuiz.set('calorieInformation', foodQuizData.calorieInformation);
    foodQuiz.set('dailydrinks', foodQuizData.dailydrinks);
    /*
    foodQuiz.set('weeklyalcohol', foodQuizData.weeklyalcohol);
    foodQuiz.set('weeklyprocessedmeats', foodQuizData.weeklyprocessedmeats);
    foodQuiz.set('weeklyrefinedcarbs', foodQuizData.weeklyrefinedcarbs);
    foodQuiz.set('weeklyfriedfoods', foodQuizData.weeklyfriedfoods);
    foodQuiz.set('weeklydesserts', foodQuizData.weeklydesserts);
    */
   
    foodQuiz.set('user_id', this.getObjectId());
    return foodQuiz.save();
  }

  /*
  public setsdohquiz(sdohQuizData:any) : Promise <any> {
    const SdohQuiz = Parse.Object.extend("SdohQuiz");
    const sdohQuiz = new SdohQuiz();
    
    sdohQuiz.set("household_member", sdohQuizData.household_member);
    sdohQuiz.set("family_income", sdohQuizData.family_income);
    sdohQuiz.set("basic_requirements", sdohQuizData.basic_requirements);
    sdohQuiz.set("supported_by", sdohQuizData.supported_by);
    sdohQuiz.set("housing_situation", sdohQuizData.housing_situation);
    sdohQuiz.set("work_situation", sdohQuizData.work_situation);
    sdohQuiz.set("current_work", sdohQuizData.current_work);
    sdohQuiz.set("refugee", sdohQuizData.refugee);
    sdohQuiz.set("discrimination", sdohQuizData.discrimination);
    sdohQuiz.set("crime_records", sdohQuizData.crime_records);
    sdohQuiz.set("afraid_of_partner", sdohQuizData.afraid_of_partner);
    sdohQuiz.set("primary_member_situation", sdohQuizData.primary_member_situation);
    sdohQuiz.set("discharged_from_armed_forces", sdohQuizData.discharged_from_armed_forces);
    sdohQuiz.set("zip", sdohQuizData.zip);
    sdohQuiz.set("fluent_english", sdohQuizData.fluent_english);
    sdohQuiz.set("understanding_insurance_benifits", sdohQuizData.understanding_insurance_benifits);
    sdohQuiz.set("current_problems", sdohQuizData.current_problems);
    
    
    sdohQuiz.set("user_id", this.getObjectId());
    return sdohQuiz.save();
  }
  */

  
  public async getHeight() : Promise<number> {
    var query = new Parse.Query('RiskQuiz');
    var w : number = 0;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    w = results[0].get('risk8');
    return w;
  }

  public async getCurrentWeight(): Promise<number> {
    const query = new Parse.Query('Weight');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    query.addDescending('date');
    query.limit(1);
    const results = await query.find();
    w = results[0].get('weight');
    return w;
  }

  public async getCurrentBMI(): Promise<number> {
    const query = new Parse.Query('Weight');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    query.addDescending('date');
    query.limit(1);
    const results = await query.find();
    w = results[0].get('BMI');
    return w;
  }

  public async getCurrentBMICoach(): Promise<number> {
    const query = new Parse.Query('Weight');
    let w = 0;
    query.equalTo('user_id', this.cookie.get('patientID'));
    query.addDescending('date');
    query.limit(1);
    const results = await query.find();
    w = results[0].get('BMI');
    return w;
  }

  public async getWeightGoal(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    w = results[0].get('weightGoal');
    return w;
  }

  public async getWeightGoalCoach(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.cookie.get('patientID'));
    const results = await query.find();
    w = results[0].get('weightGoal');
    return w;
  }

  public async getActivityGoal(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    w = results[0].get('activityGoal');
    return w;
  }

  public async getActivityGoalCoach(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.cookie.get('patientID'));
    const results = await query.find();
    w = results[0].get('activityGoal');
    return w;
  }

  public async getActivityCaloriesGoal(): Promise<number> {
      const query = new Parse.Query('ProgramGoals');
      let w = 0;
      query.equalTo('user_id', this.getObjectId());
      const results = await query.find();
      w = results[0].get('activitycaloriesGoal');
      return w;
  }

  public async getActivityCaloriesGoalCoach(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.cookie.get('patientID'));
    const results = await query.find();
    w = results[0].get('activitycaloriesGoal');
    return w;
  }

  public async getFoodCaloriesGoal(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    w = results[0].get('foodcaloriesGoal');
    return w;
  }

  public async getFoodCaloriesGoalCoach(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.cookie.get('patientID'));
    const results = await query.find();
    w = results[0].get('foodcaloriesGoal');
    return w;
  }

  public async getStepGoal(): Promise<number> {
    const query = new Parse.Query('ProgramGoals');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    const results = await query.find();
    w = results[0].get('stepsGoal');
    return w;
  }

  public createActivityLog(activityData: any): Promise<any> {
    const ActivityLog = Parse.Object.extend('Exercise');

    const activityLog = new ActivityLog();
    const d = new Date(activityData.activityDate);
    activityLog.set('time', activityData.time);
    activityLog.set('activity', activityData.activity);
    activityLog.set('date', d);
    activityLog.set('user_id', this.getObjectId());
    activityLog.set('intensity', activityData.intensity);
    activityLog.set('caloriesBurned', activityData.activityCalories);

    return activityLog.save();
  }

  public createHealthLog(healthData: any): Promise<any> {
    const HealthLog = Parse.Object.extend('HealthTest');

    const healthLog = new HealthLog();
    const d = new Date(healthData.healthDate);
    healthLog.set('waist_circumference', healthData.waist);
    healthLog.set('fasting_glucose', healthData.glucose);
    healthLog.set('blood_pressure_high', healthData.bloodhigh);
    healthLog.set('blood_pressure_low', healthData.bloodlow);
    healthLog.set('hdl', healthData.hdl);
    healthLog.set('ldl', healthData.ldl);
    healthLog.set('A1C', healthData.a1c);
    healthLog.set('date', d);
    healthLog.set('user_id', this.getObjectId());
    healthLog.set('A1C', healthData.A1C);

    return healthLog.save();
  }

  public async getActivityHistory(): Promise<LogsData[]> {
    const activityData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Exercise');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('activity', ' ');
    query.descending('date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.activity = results[i].get('activity').toString();
      data.time = results[i].get('time');
      const day = results[i].get('date').getDate();
      const month = this.getFullMonth(results[i].get('date'));
      const year = results[i].get('date').getFullYear();
      data.activityDate = month + ' ' + day + ',  ' + year;
      data.activityCalories = results[i].get('caloriesBurned');
      // data.intensity = results[i].get("intensity").toString();
      activityData.push(data);
    }
    return activityData;
  }

  public async getActivityHistoryCoach(): Promise<LogsData[]> {
    const activityData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Exercise');
    query.equalTo('user_id', this.cookie.get('patientID'));
    query.notEqualTo('activity', ' ');
    query.descending('date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.activity = results[i].get('activity').toString();
      data.time = results[i].get('time');
      const day = results[i].get('date').getDate();
      const month = this.getFullMonth(results[i].get('date'));
      const year = results[i].get('date').getFullYear();
      data.activityDate = month + ' ' + day + ',  ' + year;
      data.activityCalories = results[i].get('caloriesBurned');
      // data.intensity = results[i].get("intensity").toString();
      activityData.push(data);
    }
    return activityData;
  }

  public async getFoodHistory(): Promise<LogsData[]> {
    const foodData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Food');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('food_name', '');
    query.notEqualTo('meal_type', ' ');
    query.descending('date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.food_name = results[i].get('food_name');
      data.calories = results[i].get('calories');
      data.meal_type = results[i].get('meal_type');
      const day = results[i].get('date').getDate();
      const month = this.getFullMonth(results[i].get('date'));
      const year = results[i].get('date').getFullYear();
      data.foodDate = month + ' ' + day + ',  ' + year;
      data.calories = results[i].get('calories');
      foodData.push(data);
    }
    return foodData;
  }

  public async getFoodHistoryCoach(): Promise<LogsData[]> {
    const foodData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Food');
    query.equalTo('user_id', this.cookie.get('patientID'));
    query.notEqualTo('food_name', '');
    query.notEqualTo('meal_type', ' ');
    query.descending('date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.food_name = results[i].get('food_name');
      data.meal_type = results[i].get('meal_type');
      const day = results[i].get('date').getDate();
      const month = this.getFullMonth(results[i].get('date'));
      const year = results[i].get('date').getFullYear();
      data.foodDate = month + ' ' + day + ',  ' + year;
      data.calories = results[i].get('calories');
      foodData.push(data);
    }
    return foodData;
  }

  public async getWeightHistory(): Promise<LogsData[]> {
    const weightData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Weight');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('weight', '');
    query.descending('date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.weight = results[i].get('weight');
      // console.log(results[i].get("date"));
      const day = results[i].get('date').getDate();
      const month = this.getFullMonth(results[i].get('date'));
      const year = results[i].get('date').getFullYear();
      data.weightDate = month + ' ' + day + ',  ' + year;
      weightData.push(data);

    }
    return weightData;
  }

  public async getWeightHistoryCoach(): Promise<LogsData[]> {
    const weightData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Weight');
    query.equalTo('user_id', this.cookie.get('patientID'));
    query.notEqualTo('weight', '');
    query.descending('date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.weight = results[i].get('weight');
      // console.log(results[i].get("date"));
      const day = results[i].get('date').getDate();
      const month = this.getFullMonth(results[i].get('date'));
      const year = results[i].get('date').getFullYear();
      data.weightDate = month + ' ' + day + ',  ' + year;
      weightData.push(data);

    }
    return weightData;
  }

  public async getOngoingFoodPlanHistory(): Promise<LogsData[]> {
    const planData = [];
    const query = new Parse.Query('FoodPlan');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('plan', '');
    query.notEqualTo('measurable', '');
    query.notEqualTo('currentTime', '');
    query.notEqualTo('status', '');
    query.notEqualTo('specific', '');
    query.equalTo('status', 'ongoing');
    query.ascending('days');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.foodplan = results[i].get('plan');
      data.plannedFood = results[i].get('specific');
      data.plannedTimes = results[i].get('measurable');
      data.currentTimes = results[i].get('currentTime');
      data.foodStatus = results[i].get('status');
      data.days = results[i].get('days');
      data.foodPlanId = results[i].id;
      planData.push(data);
    }
    return planData;
  }

  public async getOngoingProgram(): Promise<LogsData[]> {
    const programData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Program');
    query.equalTo('is_active', true);
    query.descending('start_date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.code = results[i].get('program_code');
      data.coachname = results[i].get('coach_name');
      data.title = results[i].get('title');
      data.program_id = results[i].id;
      const start_day = results[i].get('start_date').getDate();
      const start_month = this.getFullMonth(results[i].get('start_date'));
      const start_year = results[i].get('start_date').getFullYear();
      let start_timeHours = results[i].get('start_date').getHours();
      let ampm = 'am';
      if (start_timeHours > 12) {
        start_timeHours -= 12;
        ampm = 'pm';
      }
      let start_timeMinutes = results[i].get('start_date').getMinutes();
      if (start_timeMinutes < 10) {
        start_timeMinutes = '0' + start_timeMinutes;
      }

      const startt = (start_timeHours + 1) + ':' + (start_timeMinutes) + ' ' + ampm;
      data.startdate = start_month + ' ' + start_day + ',  ' + start_year;
      const end_day = results[i].get('end_date').getDate();
      const end_month = this.getFullMonth(results[i].get('end_date'));
      const end_year = results[i].get('end_date').getFullYear();
      let end_timeHours = results[i].get('end_date').getHours();
      let pmam = 'am';
      if (end_timeHours > 12) {
        end_timeHours -= 12;
        pmam = 'pm';
      }

      let end_timeMinutes = results[i].get('end_date').getMinutes();
      if (end_timeMinutes < 10) {
        end_timeMinutes = '0' + end_timeMinutes;
      }
      const endt = (end_timeHours + 1) + ':' + (end_timeMinutes) + ' ' + pmam;
      data.programtime = startt + ', to ' + endt;
      data.enddate = end_month + ' ' + end_day + ',  ' + end_year;
      programData.push(data);
    }
    return programData;
  }

  public async getCoachClasses(): Promise<LogsData[]> {
    const programData = [];
    const currentDate = new Date();
    const query = new Parse.Query('Program');
    query.equalTo('is_active', true);
    query.equalTo('coach_id', this.getObjectId());
    query.descending('start_date');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.code = results[i].get('program_code');
      data.coachname = results[i].get('coach_name');
      data.title = results[i].get('title');
      data.programtime = results[i].get('start_time');
      data.program_id = results[i].id;
      const start_day = results[i].get('start_date').getDate();
      const start_month = this.getFullMonth(results[i].get('start_date'));
      const start_year = results[i].get('start_date').getFullYear();
      let start_timeHours = results[i].get('start_date').getHours();
      let ampm = 'am';
      if (start_timeHours > 12) {
        start_timeHours -= 12;
        ampm = 'pm';
      }
      let start_timeMinutes = results[i].get('start_date').getMinutes();
      if (start_timeMinutes < 10) {
        start_timeMinutes = '0' + start_timeMinutes;
      }

      const startt = (start_timeHours + 1) + ':' + (start_timeMinutes) + ' ' + ampm;
      data.startdate = start_month + ' ' + start_day + ',  ' + start_year;
      const end_day = results[i].get('end_date').getDate();
      const end_month = this.getFullMonth(results[i].get('end_date'));
      const end_year = results[i].get('end_date').getFullYear();
      let end_timeHours = results[i].get('end_date').getHours();
      let pmam = 'am';
      if (end_timeHours > 12) {
        end_timeHours -= 12;
        pmam = 'pm';
      }

      let end_timeMinutes = results[i].get('end_date').getMinutes();
      if (end_timeMinutes < 10) {
        end_timeMinutes = '0' + end_timeMinutes;
      }
      const endt = (end_timeHours + 1) + ':' + (end_timeMinutes) + ' ' + pmam;
      // data.programtime = startt + ', to ' + endt;
      data.enddate = end_month + ' ' + end_day + ',  ' + end_year;
      programData.push(data);
    }
    return programData;
  }
  public async getCoachPatients(): Promise<LogsData[]> {
    const programData = [];
    const query = new Parse.Query('User');
    query.equalTo('program_id', this.cookie.get('program_id'));
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.patient = results[i].id;
      data.name = results[i].get('name');

      programData.push(data);
    }
    return programData;
  }

  public async getOngoingActivityPlanHistory(): Promise<LogsData[]> {
    const planData = [];
    const currentDate = new Date();
    const query = new Parse.Query('ExercisePlan');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('measurable', '');
    query.notEqualTo('day', '');
    query.notEqualTo('specific', '');
    query.equalTo('status', 'ongoing');
    query.ascending('day');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      console.log('status is ' + results[i].get('status'));
      const data = new LogsData();
      data.planactivity = results[i].get('specific');
      data.planminutes = results[i].get('measurable');
      data.activitydays = results[i].get('day');
      data.activityStatus = results[i].get('status');
      data.activityPlanId = results[i].id;
      planData.push(data);
    }
    return planData;
  }

  public async getPastFoodPlanHistory(): Promise<LogsData[]> {
    const planData = [];
    const query = new Parse.Query('FoodPlan');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('plan', '');
    query.notEqualTo('measurable', '');
    query.notEqualTo('currentTime', '');
    query.notEqualTo('status', '');
    query.notEqualTo('specific', '');
    query.notEqualTo('status', 'ongoing');
    query.descending('days');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.foodplan = results[i].get('plan');
      data.plannedFood = results[i].get('specific');
      data.plannedTimes = results[i].get('measurable');
      data.currentTimes = results[i].get('currentTime');
      data.foodStatus = results[i].get('status');
      data.days = results[i].get('days');
      data.foodPlanId = results[i].id;
      planData.push(data);
    }
    return planData;
  }

  public async getPastActivityPlanHistory(): Promise<LogsData[]> {
    const planData = [];
    const query = new Parse.Query('ExercisePlan');
    query.equalTo('user_id', this.getObjectId());
    query.notEqualTo('measurable', '');
    query.notEqualTo('day', '');
    query.notEqualTo('status', '');
    query.notEqualTo('specific', '');
    query.notEqualTo('status', 'ongoing');
    query.descending('day');
    const results = await query.find();
    for (let i = 0; i < results.length; i++) {
      const data = new LogsData();
      data.planactivity = results[i].get('specific');
      data.planminutes = results[i].get('measurable');
      data.activitydays = results[i].get('day');
      data.activityStatus = results[i].get('status');
      data.activityPlanId = results[i].id;
      planData.push(data);
    }
    return planData;
  }

  public async getAccountDetails(): Promise<UserData> {
    const accountData = new UserData();
    const userQuery = new Parse.Query('User');
    userQuery.equalTo('objectId', this.getObjectId());
    const results = await userQuery.find();
    for (let i = 0; i < results.length; i++) {
      accountData.FullName = results[i].get('name');
      accountData.Email = results[i].get('username');
      accountData.coachID = results[i].get('coach_id'); // rm
    }

    const riskQuery = new Parse.Query('RiskQuiz');
    riskQuery.equalTo('user_id', this.getObjectId());
    const r = await riskQuery.find();
    for (let i = 0; i < results.length; i++) {
      accountData.age = r[i].get('risk1').toString();
      accountData.height = r[i].get('risk8');
      accountData.gender = r[i].get('risk2');
      accountData.race = r[i].get('risk5');
      accountData.riskScore = r[i].get('risk_score').toString();
    }
    return accountData;
  }

  public getObjectId(): string {
    return this.cookie.get('userObjectId');
  }

  public getRiskQuizId(): string {
    return this.cookie.get('riskQuizObjectId');
  }

  public getFoodLogId() : string {
    return this.cookie.get('foodLogObjectId');
  }

  public async getProgramGoalsId(): Promise<string> {
    const query = new Parse.Query('User');
    console.log('getting prog goal id');
    query.equalTo('objectId', this.getObjectId());
    const results = await query.find();
    const w = results[0].get('programGoalId');
    return w;
  }

  public updateAge(age: Number): boolean {
    const query = new Parse.Query('User');
    query.get(this.getObjectId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set('age', age);
      user.save();
    }, (error) => {
      console.log('ERROR getting user from db');
      return false;
      // The object was not retrieved successfully.
    });
    return true;
  }

  public setQuizData(userRiskQuizData: QuizData) {
    const query = new Parse.Query('RiskQuiz');
    query.get(this.getRiskQuizId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set('risk1', userRiskQuizData.age);
      user.set('risk2', userRiskQuizData.gender);
      user.set('risk3', userRiskQuizData.gestational);
      user.set('risk4', userRiskQuizData.family);
      user.set('risk5', userRiskQuizData.ethnicity);
      user.set('risk6', userRiskQuizData.bp);
      user.set('risk7', userRiskQuizData.active);
      user.set('risk8', userRiskQuizData.height);
      user.set('risk9', userRiskQuizData.weight);
      user.set('risk_score', userRiskQuizData.score);
      user.set('user_id', this.getObjectId());

      user.save();
      console.log('SUCCEEDED in updating risk quiz data');
    }, (error) => {
      console.log('ERROR updating risk quiz data');
      // The object was not retrieved successfully.
    });
  }


  // Motivation Quiz
  public createMotivationQuiz() : Promise <any> {
    const MotivQuiz = Parse.Object.extend('MotivationQuiz');
    var mquiz = new MotivQuiz();
    return mquiz.save();
  }

  public getMotivObjectId(): string {
    return this.cookie.get('userMotivObjectId');
  }

  public getMotiveQuizId() : string {
    return this.cookie.get('motivQuizObjectId');
  }

  public setMotivationQuizData(userMotivation : QuizData) {
    var query = new Parse.Query('MotivationQuiz');
    query.get(this.getMotiveQuizId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set('motivation1', userMotivation.motiv);
      user.set('motivation2', userMotivation.whyChange);
      user.set('motivation3', userMotivation.habit);
      user.set('motivation4', userMotivation.whatHappen);
      
      user.set('user_id', this.getObjectId());

      user.save();
      console.log('SUCCEEDED in updating motivation quiz data');
    }, (error) => {
      console.log('ERROR updating motivation quiz data');
      // The object was not retrieved successfully.
    });
  }

  // public getRiskScore() : String {
  //   console.log("in getRiskScore");
  //   var query = new Parse.Query("RiskQuiz");
  //   query.get(this.getRiskQuizId()).then((user) => {
  //     console.log(user.get("risk_score"));
  //     return user.get("risk_score");
  //   }, (error) => {
  //       // The object was not retrieved successfully.
  //   });
  //   return null;
  // }

  public async getRiskScore(): Promise<number> {
    const query = new Parse.Query('RiskQuiz');
    let w = 0;
    query.equalTo('user_id', this.getObjectId());
    query.addDescending('date');
    query.limit(1);
    const results = await query.find();
    w = results[0].get('risk_score');
    return w;
  }

  public getWeight(): Number {
    const query = new Parse.Query('User');
    query.get(this.getObjectId()).then((user) => {
      return user.get('weight');
    }, (error) => {
      // The object was not retrieved successfully.
    });
    return null;
  }

  // demographic quiz

  public createDemoQuiz(): Promise<any> {
    const DemoQuiz = Parse.Object.extend('DemographicQuiz');
    const dquiz = new DemoQuiz();
    return dquiz.save();
  }


  public getDemoObjectId(): string {
    return this.cookie.get('userDemoObjectId');
  }

  public getDemoQuizId(): string {
    return this.cookie.get('demoQuizObjectId');
  }


  public setDemoQuizData(userDemoQuizData: QuizData) {
    const query = new Parse.Query('DemographicQuiz');
    query.get(this.getDemoQuizId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set('demo_enrolled', userDemoQuizData.enrolled);
      user.set('demo_zip', userDemoQuizData.zip);
      user.set('demo_education', userDemoQuizData.education);
      user.set('demo_payer', userDemoQuizData.payer);
      user.set('demo_diabetes', userDemoQuizData.diabetes);
      user.set('demo_prediabetes', userDemoQuizData.prediabetes);
      user.set('user_id', this.getObjectId());

      user.save();
      console.log('SUCCEEDED in updating demographic quiz data');
    }, (error) => {
      console.log('ERROR updating risk quiz data');
      // The object was not retrieved successfully.
    });
  }

  //SDOH quiz

  public createSdohQuiz() : Promise <any> {
    const SdohQuiz = Parse.Object.extend('SdohQuiz');
    var squiz = new SdohQuiz();
    return squiz.save();
  }


  public getSdohObjectId(): string {
    return this.cookie.get('userSdohObjectId');
  }

  public getSdohQuizId(): string {
    return this.cookie.get('sdohQuizObjectId');
  }


  public setSdohQuizData(sdohQuizData : QuizData) {
    var query = new Parse.Query('SdohQuiz');
    query.get(this.getSdohQuizId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set("household_member", sdohQuizData.household_member);
      user.set("family_income", sdohQuizData.family_income);
      user.set("basic_requirements", sdohQuizData.basic_requirements);
      user.set("supported_by", sdohQuizData.supported_by);
      user.set("housing_situation", sdohQuizData.housing_situation);
      user.set("work_situation", sdohQuizData.work_situation);
      user.set("regular_sources", sdohQuizData.regularSources);
      user.set("quality_groceries", sdohQuizData.qualityGroceries);
      //user.set("current_work", sdohQuizData.current_work);
      //user.set("refugee", sdohQuizData.refugee);
      /*
      user.set("discrimination", sdohQuizData.discrimination);
      user.set("crime_records", sdohQuizData.crime_records);
      user.set("afraid_of_partner", sdohQuizData.afraid_of_partner);
      user.set("primary_member_situation", sdohQuizData.primary_member_situation);
      user.set("discharged_from_armed_forces", sdohQuizData.discharged_from_armed_forces);
      user.set("zip", sdohQuizData.zip);
      user.set("fluent_english", sdohQuizData.fluent_english);
      */
      user.set("understanding_insurance_benifits", sdohQuizData.understanding_insurance_benifits);
      user.set("current_problems", sdohQuizData.current_problems);

      user.set("user_id", this.getObjectId());

      user.save();
      console.log('SUCCEEDED in updating SDOH quiz data');
    }, (error) => {
        console.log("ERROR updating SDOH quiz data");
        // The object was not retrieved successfully.
    });
  }
  public setSdohQuiz2Data(sdohQuiz2Data : QuizData) {
    var query = new Parse.Query("SdohQuiz");
    query.get(this.getSdohQuizId()).then((user) => {
      user.set("discrimination", sdohQuiz2Data.discrimination);
      user.set("related_problems", sdohQuiz2Data.related_problems);
      //user.set("afraid_of_partner", sdohQuiz2Data.afraid_of_partner);
      user.set("primary_member_situation", sdohQuiz2Data.primary_member_situation);
      //user.set("discharged_from_armed_forces", sdohQuiz2Data.discharged_from_armed_forces);
      //user.set("zip", sdohQuiz2Data.zip);
      user.set("counseling", sdohQuiz2Data.counseling);
      user.set("fluent_english", sdohQuiz2Data.fluent_english);
      //user.set("understanding_insurance_benifits", sdohQuiz2Data.understanding_insurance_benifits);
      user.save();

      console.log('SUCCEEDED in updating SDOH quiz part 2 data');
    }, (error) => {
      // console.log(error);
      console.log('ERROR updating SDOH quiz part 2 data');
      // The object was not retrieved successfully.
    });

  }

  //Comorbidity quiz

  public createComorbidityQuiz() : Promise <any> {
    const ComorbidityQuiz = Parse.Object.extend("ComorbidityQuiz");
    var cquiz = new ComorbidityQuiz();
    return cquiz.save();
  }


  public getComorbidityObjectId(): string {
    return this.cookie.get("userComorbidityObjectId");
  }

  public getComorbidityQuizId(): string {
    return this.cookie.get("comorbidityQuizObjectId");
  }


  public setComorbidityQuizData(comorbidityQuizData : QuizData) {
    var query = new Parse.Query("ComorbidityQuiz");
    query.get(this.getComorbidityQuizId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set("preexisting_conditions", comorbidityQuizData.preexisting_conditions);
      user.set("health_status", comorbidityQuizData.health_status);
      user.set("user_id", this.getObjectId());

      user.save();
      console.log("SUCCEEDED in updating Comorbidity quiz data");
    }, (error) => {
        console.log("ERROR updating Comorbidity quiz data");
        // The object was not retrieved successfully.
    });
  }

  //Preference quiz

  public createPreferenceQuiz() : Promise <any> {
    const PreferenceQuiz = Parse.Object.extend("PreferenceQuiz");
    var pquiz = new PreferenceQuiz();
    return pquiz.save();
  }


  public getPreferenceObjectId(): string {
    return this.cookie.get("userPreferenceObjectId");
  }

  public getPreferenceQuizId(): string {
    return this.cookie.get("preferenceQuizObjectId");
  }


  public setPreferenceQuizData(preferenceQuizData : QuizData) {
    var query = new Parse.Query("PreferenceQuiz");
    query.get(this.getPreferenceQuizId()).then((user) => {
      // The object was retrieved successfully and it is ready to update.
      user.set("preference_expert", preferenceQuizData.preference_expert);
      user.set("preference_health_education", preferenceQuizData.preference_health_education);
      user.set("smartphone_usage", preferenceQuizData.smartphone_usage);

      user.set("user_id", this.getObjectId());

      user.save();
      console.log("SUCCEEDED in updating Preference quiz data");
    }, (error) => {
        console.log("ERROR updating Preference quiz data");
        // The object was not retrieved successfully.
    });
  }

  //Coach view feedback

  public setCoachFeedbackDataActivity(coachFeedbackData : QuizData): Promise <any> {
    const User = Parse.Object.extend("CoachFeedback");
    var user = new User();
    user.set("weekly_log", coachFeedbackData.weekly_log);
    user.set("feedback", coachFeedbackData.positives_negatives);
    user.set("specific_suggestion", coachFeedbackData.specific_suggestion);
    user.set("patient_id", this.cookie.get('patientID'));
    user.set("coach_id", this.getObjectId());
    user.set("trend", 'activity');

    return user.save();
  }

  public setCoachFeedbackDataFood(coachFeedbackData : QuizData): Promise <any> {
    const User = Parse.Object.extend("CoachFeedback");
    var user = new User();
    user.set("weekly_log", coachFeedbackData.weekly_log);
    user.set("feedback", coachFeedbackData.positives_negatives);
    user.set("specific_suggestion", coachFeedbackData.specific_suggestion);
    user.set("patient_id", this.cookie.get('patientID'));
    user.set("coach_id", this.getObjectId());
    user.set("trend", 'food');

    return user.save();
  }

  public setCoachFeedbackDataWeight(coachFeedbackData : QuizData): Promise <any> {
    const User = Parse.Object.extend("CoachFeedback");
    var user = new User();
    user.set("weekly_log", coachFeedbackData.weekly_log);
    user.set("feedback", coachFeedbackData.positives_negatives);
    user.set("specific_suggestion", coachFeedbackData.specific_suggestion);
    user.set("patient_id", this.cookie.get('patientID'));
    user.set("coach_id", this.getObjectId());
    user.set("trend", 'weight');

    return user.save();
  }


  public setPhoneNumber(QuizData:any) : Promise <any> {
    const PhoneData = Parse.Object.extend('User');

    const phoneData = new PhoneData();
    phoneData.set('phoneNumber', QuizData.phone);

    
    return phoneData.save();
  }


  public Login(userLoginData: UserData) {
    this.LoggedIn = false;
    return Parse.User.logIn(userLoginData.Email, userLoginData.password);
  }


  public resetPassword(emailAddress: string): string {
    console.log('here in reset password');
    Parse.User.requestPasswordReset(emailAddress)
      .then(() => {
        // Password reset request was sent successfully
        alert('Please check your email to complete your password reset');
        return 'SUCCESS';
      }, (error) => {
        // Show the error message somewhere
        console.log(error);
        alert('Error: ' + error.code + ' ' + error.message);
        return 'ERROR';
      });
    // .catch((error) => {
    //   // Show the error message somewhere
    //   console.log(error)
    //   alert("Error: " + error.code + " " + error.message);
    //   return "ERROR"
    // });
    return 'Error';
  }
  public getFullDay(date: Date): string {
    const d = date.getDay();
    switch (d) {
      case 0:
        return 'Sun';
        break;
      case 1:
        return 'Mon';
        break;
      case 2:
        return 'Tue';
        break;
      case 3:
        return 'Wed';
        break;
      case 4:
        return 'Thu';
        break;
      case 5:
        return 'Fri';
        break;
      case 6:
        return 'Sat';
        break;
      default:
        return '';
    }
  }

  public getFullMonth(date: Date): string {
    const m = date.getMonth();
    switch (m) {
      case 0:
        return 'January';
        break;
      case 1:
        return 'February';
        break;
      case 2:
        return 'March';
        break;
      case 3:
        return 'April';
        break;
      case 4:
        return 'May';
        break;
      case 5:
        return 'June';
        break;
      case 6:
        return 'July';
        break;
      case 7:
        return 'August';
        break;
      case 8:
        return 'September';
        break;
      case 9:
        return 'October';
        break;
      case 10:
        return 'November';
        break;
      case 11:
        return 'December';
        break;
      default:
        return '';
    }
  }

  public saveCoachData(coachData, classDate): Promise<any> {
    console.log('saving coach data');
    const CoachData = Parse.Object.extend('CoachData');
    const coachdata = new CoachData();

    coachdata.set('patient_id', coachData.patient);
    coachdata.set('attendance', coachData.attendance);
    coachdata.set('wkly_activity_mins', coachData.activityminutes);
    coachdata.set('wkly_weight', coachData.weight);
    coachdata.set('class_date', new Date(classDate));
    coachdata.set('user_id', this.getObjectId());

    return coachdata.save();
  }
}
